import { Controller } from "@hotwired/stimulus";

// Toggles the abandon-note textarea based on the selected outcome radio.
// Markup:
//   data-controller="finish-plan-form"
//   <input type="radio" name="outcome" value="abandon"
//          data-finish-plan-form-target="radio"
//          data-action="change->finish-plan-form#onChange">
//   <div data-finish-plan-form-target="noteField">...</div>
export default class extends Controller {
  static targets = ["radio", "noteField"];

  declare readonly radioTargets: HTMLInputElement[];
  declare readonly noteFieldTarget: HTMLElement;

  onChange() {
    const selected = this.radioTargets.find((r) => r.checked);
    const showNote = selected?.value === "abandon";
    this.noteFieldTarget.classList.toggle("hidden", !showNote);

    if (showNote) {
      // Wait a tick so the element is laid out before scrolling.
      requestAnimationFrame(() => {
        if (typeof this.noteFieldTarget.scrollIntoView === "function") {
          this.noteFieldTarget.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      });
    }
  }
}
